function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAzure = function SvgAzure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#1874ba",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1874ba",
    d: "m4.7 18.7h15.3l-8.2-14-2.6 6.8 4.7 5.5z",
    style: {
      fill: "#1874ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1874ba",
    d: "m10.7 3.3-6.2 14h-4.5l5-8.9z",
    style: {
      fill: "#1874ba"
    }
  })));
};
export default SvgAzure;